import * as Counter from "./counter";
import * as Todo from "./todo";
import * as Journal from "./journal";
import * as School from "./school";

export default [Counter, Todo, Journal, School];
